import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
    selector: 'invoices-statements-filter-widget',
    templateUrl: './invoices-statements-filter-widget.component.html',
    styleUrls: ['./invoices-statements-filter-widget.component.scss']
})
export class InvoicesStatementsFilterWidgetComponent implements OnInit {

    filterOptionsForm: FormGroup;
    @Output() filterFormValues: EventEmitter<any> = new EventEmitter<any>();
    @Input() clearFilter = false;

    constructor(private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.createFilterOptionsForm();
    }

    // tslint:disable-next-line:use-lifecycle-interface
    ngOnChanges() {
        if (this.clearFilter) {
            this.filterOptionsForm.reset();
        }
    }


    searchByIdentifier(data?: any) {
        this.clearFilter = false;
        const identifier = data?.target?.value;
        this.filterOptionsForm.patchValue({
            filterByIdentifier: identifier
        });
        this.filterOptionsForm.patchValue({
            fromDate: '',
            toDate: ''
        });
        this.filterFormValues.emit({
            toFilter: this.filterOptionsForm.value
        });
    }

    resetSearchBar() {
        this.filterOptionsForm.patchValue({
            filterByIdentifier: ''
        });
    }

    applyFilterOptions() {
        this.clearFilter = false;
        this.filterOptionsForm.patchValue({
            filterIdentifier: ''
        });
        this.filterFormValues.emit({
            toFilter: this.filterOptionsForm.value
        });
    }

    createFilterOptionsForm(selectedFilters?: any) {
        this.filterOptionsForm = new FormGroup({
            filterByIdentifier: new FormControl(''),
            fromDate: new FormControl(''),
            toDate: new FormControl('')
        });
    }
}
